import request from '@/utils/request'

export const getdatalist = (params: any) =>
  request({
    url: '/operatehistory/gethistory',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
  // request({
  //   url: '/api/autolearncount',
  //   method: 'post',
  //   data: params,
  //   headers: {
  //     'Content-Type': 'application/json'
  //   }
  // })
